/** Textes « releveKm » — le français fait foi. */
export const releveKm = {
  titre: 'Relever un kilométrage',
  conserveNonApplique: (saisi: string, precedent: string, u: string) =>
    `Relevé conservé, mais NON appliqué : ${saisi} ${u} est inférieur au compteur (${precedent} ${u}).`,
  applique: (immat: string, precedent: string, saisi: string, u: string) => `${immat} : ${precedent} → ${saisi} ${u}.`,
  erreur: 'Enregistrement impossible',
  horsPeriode: 'Ce n’est pas la période du relevé',
  periodeOuverte: 'Période de relevé ouverte',
  seRelevent: 'Les compteurs se relèvent ',
  du1au3a: 'du 1',
  er: 'er',
  du1au3b: ' au 3',
  et: ' et ',
  du15au18: 'du 15 au 18',
  chaqueMois: ' de chaque mois.',
  bloque: (jour: number) => ` Nous sommes le ${jour} : revenez à la prochaine période, ou demandez à un gérant, qui peut relever à tout moment.`,
  ouvert: (jour: number) => ` Nous sommes le ${jour} : c’est le moment.`,
  vehicule: 'Véhicule',
  choisir: '— choisir —',
  compteur: 'Kilométrage au compteur',
  dernierConnu: (km: string, u: string) => `Dernier connu : ${km} ${u}.`,
  depuis: (ecart: string, u: string) => `+${ecart} ${u} depuis le dernier relevé.`,
  inferieurTitre: 'Ce chiffre est inférieur au compteur',
  inferieurA: 'Un compteur ne recule pas. Le relevé sera conservé pour la trace, mais le kilométrage de la voiture ne sera ',
  pas: 'pas',
  inferieurB: ' modifié. Vérifiez votre saisie.',
  commentaire: 'Commentaire',
  commentaireAide: 'Facultatif — « au plein », « retour du garage »…',
  derniers: 'Derniers relevés',
  sources: { saisie: 'Saisie directe', etat_des_lieux: 'État des lieux', entretien: 'Entretien' } as Record<string, string>,
  annuler: 'Annuler',
  enregistrement: 'Enregistrement…',
  enregistrer: 'Enregistrer le relevé',
};
